export const OfferValidity = {
	DAY:       'day',
	WEEK:      'week',
	MONTH:     'month',
	QUARTER:   'quarter',
	HALF_YEAR: 'half_year',
	YEAR:      'year',
	PERMANENT: 'permanent',
};
